
const api = {
    // 登录相关
    login:"login",
    getIpCountry:"ipcountry",
    codelogin:"codelogin",
    checkToken:"checkToken",
    logoutToken:"logoutToken",
    googlelogin:"google/login",
    facebooklogin:"facebook/login",

    //用户
    updateUserById:"user/updateUserById",
    getLoginCode:"user/getLoginCode",
    getUserById:"user/getUserById",
    getUserIntegral:"user/getUserIntegral",
    getRegisterCode:"user/getRegisterCode",
    register:"user/register",
    getResetPwdCode:"user/getResetPwdCode",
    updatePwd:"user/updatePwd",

    uploadFile:"file/upload",

    //抽奖
    luckdraw:"prizepool/luckdraw",

    //许愿
    insertMessage:"message/insert",
    getMessageByUserid:"message/list",

    //获取抽奖兑换码
    getUserexcodeByUserid:"userexcode/getByUserId",

    //兑换兑换码
    exchange:"userexcode/exchange",
    marketexchange:"userexcode/marketexchange",

    //帮助
    getHelptypeAll:"helptype/all",
    getHelpdetailList:"helpdetail/list",

    //工单类型
    getWorkOrderList:"workorder/list",
    getWordertypeAll:"wordertype/all",
    insertWorkorder:"workorder/insert",
    updateWorkorder:"workorder/update",
    //油管工单
    getToytbWorkorder:"workorder/getToytbWorkorder",

    //车票
    getTicketListByUserId:"ticket/getListByUserId",
    carinforesetpwd:"carinfo/resetpwd",
    carinforeminder:"carinfo/reminder",
    updateUticket:"ticket/upnowtike",


    //商品
    getGoodsspuAll:"goodsspu/all",
    getGoodsspuById:"goodsspu/getById",
    //计算价格
    calprice:"goodssku/calprice",

    //订单提交
    orderSubmit:"orderinfo/submit",
    getUserOrderList:"orderinfo/userlist",
    // 退款
    submitrefund:"orderinfo/userrefund",
    // payssion
    payssion:"orderinfo/payment",
    // stripe
    // stripe:"orderinfo/stripePayment",
    // pagsmailwallet
    stripe:"orderinfo/paymentpag",

    //续费
    orderRenew:"orderinfo/renew",

    //车票
    userAllTicket:"ticket/userall",
	
	
	getTicketList:"userexcode/getByGoodsAndUser",
	
	
    //国家信息
    getCountryinfoAll:"countryinfo/all",
    //省份信息
    getProvinceAll:"province/all",
    //提现
    insertWithdrawal:"withdrawal/insert",
    getWithdrawalList:'withdrawal/getByUserId',

    //获取支付地址
    getPayAddressByUserId:"payaddress/getByUserId",

    //查询所有支付方式
    paytypeall:"paytype/all",

    getCommissionList:'commission/getUserById',

    //coupon
    getCouponInfo:'discountcode/getacode',

    //联盟计划
    getOrderanalysisweeklydata:'orderinfo/orderanalysisweeklydata',
    getkolStatisData:'binduser/getkolStatisData',
    orderanalysisspu:'orderinfo/orderanalysisspu',

    getMessageList:'message/list',

    onlypay:"orderinfo/paymentonly",

    //shareAI
    getAiModelList:'aimodel/list',
    getConversationsList:'conversations/list',
    getMessageAIList:'messageAI/list',
    deleteConversation:'chat/deleteConversation',
    stopStream:'chat/stopStream',
    updateTopFlag:'conversations/updateTopFlag',
    getUserActiveSubscription:'ai-subscription/getUserActiveSubscription'

}

export default api;
